import GenericSvgIcon from "@Icons/GenericSvgIcon";
import IconType from "@/types/Icon.type";
import {Colors} from "@Styles/Colors.style";

// TODO check if necessary
function IconSeat(props: IconType) {
    const {
        width = "16",
        height = "16",
        viewBox = "0 0 16 16",
        stroke = Colors.primaryColor,
        ...rest
    } = props

    return (
        <GenericSvgIcon
            {...{width, height, viewBox, ...rest}}
            svgIconPath={(
                <path
                    d="m2.72125856 13.084146h6.37896l1.06740004-1.95378c.53934-1.10214-.32886004-2.37048-1.55106004-2.26698l-3.175122.2688c-.456702.03828-.878604-.24444-1.016046-.68112l-1.704132-5.094996c-.078294-.23487.041754-.49671.277494-.574134.56109-.184416.969072-.708096.980382-1.328334.014784-.79944-.663738-1.453602-1.463172-1.453602h-1.644114c-.534984 0-.9438396.47757-.8611992 1.00647l1.52455629 9.7285597"
                    fill="none"
                    stroke={stroke}
                    strokeLinejoin="round"
                    strokeWidth="1.2"
                    transform="translate(2.8345 1.4579)"
                />
            )}
        />
    )
}

export default IconSeat